
export class StringUtils {


  public static capitalizeFirst(chaine: string): string {
    if (chaine != null) {
      return chaine.charAt(0).toUpperCase() + chaine.slice(1);
    }
    return null;
  }

  // méthode qui extrait des éléments dans une chaîne entre deux séparateurs
  public static extractAllBetweenSeparators(chaine: string, startSep: string, endSep: string): string[] {
    const regex = new RegExp(`${startSep}(.*?)${endSep}`, 'g');
    const matches = chaine.match(regex);
    if (!matches) return [];

    return matches.map(match => match.slice(startSep.length, -endSep.length));
  }

}
